import React from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'gold' | 'outline' | 'quiet' | 'danger';
type Size = 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}
const variants: Record<Variant, string> = {
  primary: 'bg-deep text-sand hover:bg-deeper',
  gold: 'bg-gold text-deep hover:bg-gold-deep hover:text-sand',
  outline: 'border border-deep/25 text-deep hover:border-deep/50',
  quiet: 'text-muted hover:text-deep',
  /* Destructive. Uses brand Black — never Honey Gold, which signals achievement. */
  danger: 'bg-ink text-sand hover:bg-black'
};
const sizes: Record<Size, string> = {
  md: 'h-11 px-4 text-[13px]',
  lg: 'h-[52px] px-5 text-[15px]'
};
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth,
  className,
  children,
  ...rest
}: ButtonProps) {
  return <button {...rest} className={twMerge('inline-flex items-center justify-center gap-2 rounded-pill font-medium', 'transition-[background-color,border-color,color,transform] duration-150 ease-brand', 'active:scale-[0.985] disabled:opacity-50 disabled:pointer-events-none', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-sand', variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} data-id="element-1539" data-mp="83o2sspj5bb0">
      {children}
    </button>;
}